import tableDeviceTypes from './tableDeviceTypes';


export default {
  title: 'Device Types',
  noArea:true,
  attributeName: 'device-types',
  getURL: 'device-types',
  createURL: 'device-types',
  updateURL: 'device-types',
  removeURL: 'device-types',
  sessionParams: [],
  tableConfig: tableDeviceTypes,
  autoUpdate: true,
};
